export default __webpack_public_path__ + "static/media/icon-persistence.922e9da7.svg";